import React, {useContext} from 'react';

import Grid from "@material-ui/core/Grid";
import AppButton from "../../../Common/AppButton";
import useStyles from "./styles";
import PriorAuthorizationContext from "../../../../contexts/PriorAuthorization/PriorAuthorization.context";
import html2pdf from 'html2pdf.js'

export default function FormFooter(props) {
   const {handleCancel, targetRef, ...wrapperProps} = props
   const classes = useStyles();
   const { fields, setModalState, create:{currentStep, steps, nextStep, prevStep} } = useContext(PriorAuthorizationContext);

   if (!steps || !steps[currentStep]) return <></>;

   const isNextDisabled = () => steps[currentStep].hasNext ? !steps[currentStep].isValid : true
   const isBackDisabled = () => currentStep === 0

   const uploadPaSummaryPdf = async () => {
      if (!targetRef?.current) return
      
      const element = targetRef.current

      const rect = element.getBoundingClientRect()
      const widthPx = rect.width;
      const heightPx = rect.height - 2;

      const pxToIn = px => px / 96;
      const widthIn = pxToIn(widthPx)
      const heightIn = pxToIn(heightPx)

      const opt = {
         margin: [0, 0.1, 0, 0.1],
         filename: 'PA_SUMMARY.pdf',
         image: { type: 'jpeg', quality: 0.96 },
         html2canvas: { scale: 2 },
         jsPDF: { unit: 'in', format: [widthIn, heightIn], orientation: 'portrait' }
      };

      const blob = await html2pdf().set(opt).from(element).outputPdf("blob");

      // Saves pdf to review locally
      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = "PA_SUMMARY.pdf";
      // a.click();
      // URL.revokeObjectURL(url);

      const file = new File([blob], "PA_SUMMARY.pdf", {
         path: "PA_SUMMARY.pdf",
         uploadDate: new Date().toString(),
         type: "application/pdf",
         lastModified: Date.now()
      })

      file.path = "PA_SUMMARY.pdf";
      file.uploadDate = new Date().toString();

      if (fields.attachments?.value) {
         const index = fields.attachments.value.findIndex(f => f.name === "PA_SUMMARY.pdf");

         if (index >= 0) {
            fields.attachments.value[index] = file
         } else {
            fields.attachments.value.push(file)
         }
      } else {
         fields.attachments = { value: [file] };
      }
   };

   const confirmAttestation = async () => {
      setModalState({open: false, isBlocking: false})
      nextStep();
   }

   const cancelAttestModal = () => {
      setModalState({open: false})
   }
   const openAttestationModal = () => {
      uploadPaSummaryPdf()
      setModalState({
         confirm: confirmAttestation,
         confirmText: 'YES, I attest',
         confirmToolTip:  'Confirm Cancel',
         deny: cancelAttestModal,
         denyText: 'No, Go Back',
         denyToolTip: 'Go Back',
         open: true,
         title: 'I attest the information provided is true and accurate to the best of my knowledge. I understand that Medi-Cal Rx or its designees may perform a routine audit and request the medical information necessary to verify the accuracy of the information reported on this form.'
      });
   }

   const genericProps = {
      disableTooltip: true,
      size: 'large',
      buttonStyle: {minWidth: '115px', maxWidth: '115px'},
   }

   return (
      <div id='MEDCAL_RX_CREATE_PA_FORM_FOOTER' {...wrapperProps} >
         <Grid container spacing={1} className={classes.stepperActions}>
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  disabled={isBackDisabled()}
                  id='MEDCAL_RX_CREATE_PA_BACK'
                  text='Previous'
                  onClick={ prevStep }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_BACK'}}
                  {...genericProps}
               />
            </Grid>
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-cancel'
                  id='MEDCAL_RX_CREATE_PA_CANCEL'
                  text='Cancel'
                  onClick={ handleCancel }
                  variant={'outlined'}
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_CANCEL'}}
                  {...genericProps}
               />
            </Grid>
            {currentStep < steps.length - 1 &&
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  id='MEDCAL_RX_CREATE_PA_NEXT'
                  text="next"
                  disabled={ isNextDisabled() }
                  onClick={ nextStep }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_NEXT'}}
                  {...genericProps}
               />
            </Grid>}
            {currentStep === steps.length - 1 &&
            <Grid container item style={{maxWidth: 'fit-content'}} >
               <AppButton
                  className='btn-primary'
                  id='MEDCAL_RX_CREATE_PA_NEXT'
                  text="SUBMIT"
                  onClick={ openAttestationModal }
                  buttonProps={{'data-testid': 'MEDCAL_RX_CREATE_PA_NEXT'}}
                  {...genericProps}
               />
            </Grid>}
         </Grid>
      </div>
   )
};
